import React, { useEffect, useState } from 'react'
import '../assets/css/navbar.css'
import image from '../assets/images/companyLogo.png'
import ExpertMode from './ExpertMode';
import { Link, useNavigate } from 'react-router-dom';

export default function Navbar(props) {
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [userQuery, setUserQuery] = useState('');
  const nav = useNavigate();

  const handleOffcanvasShow = () => {
    if(showOffcanvas === false){
      setShowOffcanvas(true);
    }else{
      setShowOffcanvas(false);
    }
  };

  const handleOffcanvasHide = () => {
    setShowOffcanvas(false);
  };

  const navSearch = (e) => {
    nav(`/search/recipes/${userQuery}`);
  }

  return (
    <div className='navSpecs'>
        <nav className="navbar navbar-expand-lg bg-body-tertiary ps-4 pe-4">
  <div className="container-fluid">
    <Link className="navbar-brand" to="/"><img src={image} width='300px' alt='imageNavbar'/></Link>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse ms-xxl-5 ps-xxl-4" id="navbarSupportedContent">
      <ul className="navbar-nav me-auto mb-2 mb-lg-0 ps-md-0 gap-xl-5 gap-lg-4">
        <li className="nav-item ps-xl-3 ms-xl-5">
          <Link className={props.active === 'home' ? "nav-link active" : 'nav-link'} aria-current="page" to="/">Home</Link>
        </li>
        <li className="nav-item">
          <Link className={props.active === 'recipes' ? "nav-link active" : 'nav-link'} aria-current="page" to="/recipes">Recipes</Link>
        </li>
        <li className="nav-item">
        <div className="dropdown">
            <button
                className={props.active === 'category' ? "btn dropdown-toggle ps-0 nav-link active" : 'btn dropdown-toggle ps-0 nav-link'}
                type="button"
                id="dropdownMenuButton"
                data-mdb-toggle="dropdown"
                aria-expanded="false"
            >
                Category
            </button>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <li><Link to={`/recipes/appetizer`} onClick={props.appetizer} className={props.open === 'Appetizers' ? "dropdown-item nav-link active" : 'dropdown-item nav-link'}>Appetizer</Link></li>
                <li><Link to={`/recipes/meat`} onClick={props.meat} className={props.open === 'Non-Veg' ? "dropdown-item nav-link active" : 'dropdown-item nav-link'}>Meat</Link></li>
                <li><Link to={`/recipes/drinks`} onClick={props.drink} className={props.open === 'Drinks' ? "dropdown-item nav-link active" : 'dropdown-item nav-link'}>Drinks</Link></li>
                <li><Link to={`/recipes/desserts`} onClick={props.dessert} className={props.open === 'Desserts' ? "dropdown-item nav-link active" : 'dropdown-item nav-link'}>Desserts</Link></li>
                <li><Link to={`/recipes/mainDish`} onClick={props.mainDish} className={props.open === 'Main Courses' ? "dropdown-item nav-link active" : 'dropdown-item nav-link'}>Main Dish</Link></li>
                <li><Link to={`/recipes/cereals`} onClick={props.cereal} className={props.open === 'Cereals' ? "dropdown-item nav-link active" : 'dropdown-item nav-link'}>Cereals</Link></li>
            </ul>
            </div>
        </li>
        <li className="nav-item" style={{position: 'relative', right: '10px'}}>
          <button
            className="btn nav-link"
            type="button"
            onClick={handleOffcanvasShow}
          >
            Mummy Mode
          </button>
        </li>
      </ul>
      <form className="d-flex me-4 pe-lg-5 ms-5" role="search" onSubmit={navSearch}>
        <input className="form-control me-3 ps-0 pe-5" type="input" placeholder="Search" aria-label="Search" value={userQuery} onChange={(e) => setUserQuery(e.target.value)}/>
        <button className="btn btn-color" type="submit"><i className="fa-solid fa-magnifying-glass"></i></button>
      </form>
    </div>
  </div>
</nav>
<div
      className={`offcanvas offcanvas-end${showOffcanvas ? ' show' : ''}`}
      data-bs-backdrop="static" 
      tabIndex="-1"
      id="staticBackdrop"
      aria-labelledby="staticBackdropLabel"
    >
      <div className="offcanvas-header">
        <h5 className="offcanvas-title" id="staticBackdropLabel">A Look In The Cook Book!</h5>
        <button type="button" className="btn-close" onClick={handleOffcanvasHide} aria-label="Close"></button>
      </div>
      <div className="offcanvas-body">
        <ExpertMode/>
      </div>
    </div>
    </div>
  )
}
